import React from "react";
import PageHeader from "../../components/PageHeader";
import RequestedQuoteViewComponent from "../../components/RequestedQuotes/RequestedQuoteView";

class RequestedQuoteView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Requested Quote Detail"
                            Breadcrumb={[
                                { name: "Requested Quotes", navigate: "/requested-quotes" },
                                { name: "Requested Quote Detail", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <RequestedQuoteViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RequestedQuoteView;
